export const ADD_TAB = 'ADD_TAB';
export const UPDATE_TAB = 'UPDATE_TAB_NAME';
export const CLOSE_TAB = 'CLOSE_TAB';
export const CLOSE_ALL_TABS = 'CLOSE_ALL_TABS';
